import {Injectable} from '@angular/core';
import {ApiService} from './api/api.service';
import {AfasDebtor} from '../classes/debtor';
import {AfasArticle} from '../classes/afas-article';
import {AfasInvoice} from "../classes/invoice";

@Injectable({
    providedIn: 'root'
})
export class AfasService {

    constructor(private apiService: ApiService) {
    }

    public getDebtors() {
        return this.apiService.getCallData$<AfasDebtor[]>('afas/debtors');
    }

    public getInvoices() {
        return this.apiService.getCallData$<AfasInvoice[]>('afas/invoices');
    }

    public invoiceMonth(companyId: number) {
        return this.apiService.postCall$<AfasDebtor[]>('afas/invoice/' + companyId);
    }

    public getArticles() {
        return this.apiService.getCallData$<AfasArticle[]>('afas/articles');
    }

}
